import { ReactNode } from 'react'

interface EmptyStateProps {
  icon?: ReactNode
  message: string
  action?: { label: string; onClick: () => void }
  className?: string
}

export const EmptyState = ({ icon, message, action, className = '' }: EmptyStateProps) => (
  <div className={`text-center py-12 ${className}`}>
    {icon && <div className="mb-3">{icon}</div>}
    <p className="text-gray-500 text-sm">{message}</p>
    {action && (
      <button onClick={action.onClick} className="text-primary-600 text-sm mt-1 hover:underline">
        {action.label}
      </button>
    )}
  </div>
)
